import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import { buildParamsFromObject } from '@/app/common/utils/http/http';
import { PaginatedResponse } from '@/app/common/utils/pagination/types';
import { VehicleRevisionService } from '../core/service';
import {
  VehicleRevisionConfigureParams,
  VehicleRevisionDetail,
  VehicleRevisionFindAllParams,
  VehicleRevisionListItem,
  VehicleRevisionOverdueSummary,
  VehicleRevisionRegisterParams,
  VehicleRevisionUpdateIntervalParams,
} from '../core/type';

@Injectable()
export class VehicleRevisionApiService implements VehicleRevisionService {
  private readonly baseUrl = `${environment.apiHost}/revisions`;

  constructor(private http: HttpClient) {}

  findAll(
    filter?: VehicleRevisionFindAllParams,
  ): Observable<PaginatedResponse<VehicleRevisionListItem>> {
    return this.http.get<PaginatedResponse<VehicleRevisionListItem>>(
      this.baseUrl,
      { params: buildParamsFromObject(filter) },
    );
  }

  findByChassis(chassis: string): Observable<VehicleRevisionDetail> {
    return this.http.get<VehicleRevisionDetail>(
      `${this.baseUrl}/${encodeURIComponent(chassis)}`,
    );
  }

  getOverdueSummary(): Observable<VehicleRevisionOverdueSummary> {
    return this.http.get<VehicleRevisionOverdueSummary>(
      `${this.baseUrl}/overdue-summary`,
    );
  }

  configure(
    chassis: string,
    params: VehicleRevisionConfigureParams,
  ): Observable<VehicleRevisionDetail> {
    return this.http.post<VehicleRevisionDetail>(
      `${this.baseUrl}/${encodeURIComponent(chassis)}/configure`,
      params,
    );
  }

  updateInterval(
    chassis: string,
    params: VehicleRevisionUpdateIntervalParams,
  ): Observable<VehicleRevisionDetail> {
    return this.http.patch<VehicleRevisionDetail>(
      `${this.baseUrl}/${encodeURIComponent(chassis)}/interval`,
      params,
    );
  }

  registerRevision(
    chassis: string,
    params: VehicleRevisionRegisterParams,
  ): Observable<VehicleRevisionDetail> {
    return this.http.post<VehicleRevisionDetail>(
      `${this.baseUrl}/${encodeURIComponent(chassis)}/register`,
      params,
    );
  }
}
